import { on, reducer } from 'ts-action';
import * as ecgActions from '../../ecg/actions/ecg.actions';
import * as undoActions from '../../undo/actions/undo.actions';
import * as createActions from '../actions/create.actions';
import { CreateMode } from '../utils/create.utils';

export interface CreateState {
  createMode: CreateMode | null;
  currentLeads: string[];
}

declare module 'react-redux' {
  interface DefaultRootState {
    create: CreateState;
  }
}

const initialStateFactory = (): CreateState => ({
  createMode: null,
  currentLeads: [],
});

export default reducer<CreateState>(
  initialStateFactory(),
  on(ecgActions.clean, () => initialStateFactory()),
  on(
    createActions.setMode,
    (state, { mode }): CreateState => ({ ...state, createMode: mode }),
  ),
  on(
    createActions.unsetMode,
    (state): CreateState => ({ ...state, createMode: null }),
  ),
  on(
    createActions.setLeads,
    (state, { leads }): CreateState => ({ ...state, currentLeads: leads }),
  ),
  on(
    undoActions.undo,
    undoActions.restore,
    (state, { diff: { create } }): CreateState => {
      if (!create) {
        return state;
      }
      return { ...state, ...create };
    },
  ),
);
